import React from "react";

import { Button, DeleteIcon } from "shared/ui";
import { ServiceOrderDto } from "services/serviceOrders/restModels";

import {
    ORDER_STATUS_LABELS,
    ORDER_STATUS_TONES,
    ORDER_TYPE_LABELS,
} from "features/PaymentsHistory/constants";
import { usePaymentsHistoryContext } from "features/PaymentsHistory/context";

import {
    Actions,
    AmountCell,
    CellLabel,
    CellValue,
    DateCell,
    HeaderRow,
    LinkButtons,
    LinksCell,
    List,
    NumberCell,
    Row,
    StatusCell,
    TariffCell,
    TypeCell,
} from "./styles";

// Номер счёта — строка от оператора, номер карточной оплаты — внутренний id со служебным префиксом.
const orderNumber = (order: ServiceOrderDto) =>
    order.type === "Card" ? `S${order.orderId}` : order.invoiceId;

export const OrdersTable = () => {
    const state = usePaymentsHistoryContext();

    const renderLinks = (order: ServiceOrderDto) => {
        if (order.type === "Card") {
            if (!order.receiptLink) return "—";

            return (
                <LinkButtons>
                    <Button
                        variant="outlined"
                        color="neutral"
                        size="small"
                        onClick={() => window.open(order.receiptLink!, "_blank")}
                    >
                        Чек
                    </Button>
                </LinkButtons>
            );
        }

        const isGenerating = state.generatingActInvoiceId === order.invoiceId;

        return (
            <LinkButtons>
                {order.invoiceLink && (
                    <Button
                        variant="outlined"
                        color="neutral"
                        size="small"
                        onClick={() => window.open(order.invoiceLink!, "_blank")}
                    >
                        Счёт
                    </Button>
                )}
                {order.status === "Paid" && (
                    <Button
                        variant="outlined"
                        color="neutral"
                        size="small"
                        disabled={isGenerating}
                        onClick={() => state.openAct(order)}
                    >
                        {isGenerating ? "Формируем…" : "Акт"}
                    </Button>
                )}
                {!order.invoiceLink && order.status !== "Paid" && "—"}
            </LinkButtons>
        );
    };

    return (
        <List>
            <HeaderRow>
                <div>Номер</div>
                <div>Тип</div>
                <div>Тариф</div>
                <div>Сумма</div>
                <div>Статус</div>
                <div>Документы</div>
                <div>Дата</div>
                <div />
            </HeaderRow>

            {state.orders.map((order) => (
                <Row key={`${order.type}-${orderNumber(order)}`}>
                    <NumberCell>
                        <CellLabel>Номер</CellLabel>
                        <CellValue>{orderNumber(order)}</CellValue>
                    </NumberCell>

                    <TypeCell>
                        <CellLabel>Тип</CellLabel>
                        <CellValue>{ORDER_TYPE_LABELS[order.type]}</CellValue>
                    </TypeCell>

                    <TariffCell>
                        <CellLabel>Тариф</CellLabel>
                        <CellValue>{state.tariffTitle(order)}</CellValue>
                    </TariffCell>

                    <AmountCell>
                        <CellLabel>Сумма</CellLabel>
                        <CellValue>{state.formatPrice(order.price)}</CellValue>
                    </AmountCell>

                    <StatusCell $tone={ORDER_STATUS_TONES[order.status]}>
                        <CellLabel>Статус</CellLabel>
                        <CellValue>{ORDER_STATUS_LABELS[order.status]}</CellValue>
                    </StatusCell>

                    <LinksCell>
                        <CellLabel>Документы</CellLabel>
                        {renderLinks(order)}
                    </LinksCell>

                    <DateCell>
                        <CellLabel>Дата</CellLabel>
                        <CellValue>{state.orderDate(order)}</CellValue>
                    </DateCell>

                    <Actions>
                        {order.type === "Invoice" && order.status === "New" && (
                            <Button
                                variant="text"
                                color="danger"
                                size="small"
                                onClick={() => state.openCancelDialog(order)}
                            >
                                <DeleteIcon fontSize="small" />
                            </Button>
                        )}
                    </Actions>
                </Row>
            ))}
        </List>
    );
};
